// extracted by mini-css-extract-plugin
export default {"pageTitle":"Deals_pageTitle__oBqoI","dealList":"Deals_dealList__y7ZnQ"};